import { Link } from "react-router-dom";
import { scoops } from "@/mocks/scoops";
import ScoopCard from "@/components/base/ScoopCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function LatestScoops() {
  const latest = scoops.slice(1, 5);
  const ranking = [...scoops].sort((a, b) => b.heat - a.heat).slice(0, 5);

  return (
    <section className="border-y border-background-200 bg-background-100" aria-labelledby="latest-heading">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-8 md:py-16">
        <div id="latest-heading">
          <SectionHeading
            eyebrow="最新爆料"
            title="刚刚进入求证流程的档案"
            desc="每条爆料的原始材料都要先登记、再核对。以下是最近完成可信度评级的几份档案。"
            action={{ label: "进入爆料库筛选", to: "/scoops" }}
          />
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_320px]">
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            {latest.map((scoop) => (
              <ScoopCard key={scoop.id} scoop={scoop} />
            ))}
          </div>

          <aside className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
              热门求证榜
            </h3>
            <ol className="mt-4 space-y-1">
              {ranking.map((item, index) => (
                <li key={item.id}>
                  <Link
                    to={`/scoop/${item.id}`}
                    className="group flex items-start gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-100"
                  >
                    <span
                      className={`font-label text-sm font-bold w-5 shrink-0 ${
                        index < 3 ? "text-primary-500" : "text-foreground-400"
                      }`}
                    >
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block text-[13px] leading-snug text-foreground-800 transition-colors group-hover:text-primary-600 line-clamp-2">
                        {item.title}
                      </span>
                      <span className="mt-1 block font-label text-[11px] text-foreground-400">
                        {item.category} · 热度 {item.heat}
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
            <p className="mt-4 border-t border-background-200 pt-4 text-xs leading-relaxed text-foreground-500">
              热度由站内阅读、转发与线索提交量综合计算，仅代表关注程度，不代表可信度高低。
            </p>
          </aside>
        </div>
      </div>
    </section>
  );
}